import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export type CardTone = "good" | "warn" | "info" | "none";

const TONE: Record<CardTone, string> = {
  good: "border-emerald-400/35 bg-emerald-500/5",
  warn: "border-amber-400/35 bg-amber-500/5",
  info: "border-indigo-400/35 bg-indigo-500/5",
  none: "border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-900",
};

type Props = { tone?: CardTone; children: ReactNode };

export function StepCard({ tone = "none", children }: Props) {
  return (
    <div
      className={cn(
        "flex flex-col gap-3 rounded-xl border p-3.5 text-slate-900 dark:text-slate-100",
        TONE[tone],
      )}
    >
      {children}
    </div>
  );
}
